var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-page-header d-flex flex-column",
      class: _setup.isMobile ? "ga-4" : "ga-6",
    },
    [
      !_vm.hideTitleAndPhone
        ? _c(
            "div",
            {
              staticClass: "d-flex",
              class: _setup.isMobile
                ? "flex-column"
                : "align-center justify-space-between ga-8",
            },
            [
              _c(
                "h1",
                {
                  staticClass: "text--text",
                  class: _setup.isMobile ? "text-h6" : "text-h5",
                  attrs: { "data-qa": "lpu_page_price_title" },
                },
                [_vm._v("\n      " + _vm._s(_setup.title) + "\n    ")]
              ),
              _vm._v(" "),
              !_setup.isMobile && _vm.appointmentPhone
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center ga-2 flex-shrink-0 text--text",
                      attrs: { "data-qa": "lpu_page_price_phone" },
                    },
                    [
                      _c("span", {
                        staticClass: "ui-icon-ui-call ui-icon-fz-smaller",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-subtitle-1" }, [
                        _vm._v(_vm._s(_vm.appointmentPhone)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.PricePageDescription, {
        attrs: {
          lpu: _vm.lpu,
          "town-name": _vm.townName,
          "currency-abbreviation": _vm.currencyAbbreviation,
          "price-range": _vm.priceRange,
          "price-range-doctors": _vm.priceRangeDoctors,
          "price-range-mrt": _vm.priceRangeMrt,
          "price-range-kt": _vm.priceRangeKt,
          "price-range-uzi": _vm.priceRangeUzi,
          "price-range-rentgen": _vm.priceRangeRentgen,
          "price-range-uslugi": _vm.priceRangeUslugi,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }